import { useEffect, useState } from 'react'

import { getUsageLimit, updateUsage } from '../../lib/authUserHelper'

const defaultUsage = { limit: 1000, viewCount: 0 }
export const useViewCountAndLimit = () => {
  const [viewCountAndLimit, setViewCountAndLimit] = useState(defaultUsage)

  const calculateLimit = async (userId) => {
    const [usage, error] = await getUsageLimit(userId)

    if (!error) {
      setViewCountAndLimit(usage)
      localStorage.setItem('promolayer-usage', JSON.stringify(usage))
      //Update usage percent in the firebase
      updateUsage(userId, usage?.usagePercent ?? 0).catch(console.error)
    }
  }

  useEffect(() => {
    const prevUsage = localStorage.getItem('promolayer-usage')
      ? JSON.parse(localStorage.getItem('promolayer-usage'))
      : defaultUsage
    setViewCountAndLimit(prevUsage)
  }, [])

  useEffect(() => {
    const onChange = (event) => {
      if (event.key === 'promolayer-usage') {
        setViewCountAndLimit(event.newValue)
      }
    }
    addEventListener('storage', onChange)

    return () => removeEventListener('storage', onChange)
  }, [])

  return { viewCountAndLimit, calculateLimit }
}
